import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import product from '@/view/product/index'
import case1 from '@/view/case/index'
import caseDetail from '@/view/case/detail'
import inRegard from '@/view/inRegard/index'
import contactUs from '@/view/contactUs/index'
import news from '@/view/news/index'
import newsDetail from '@/view/news/detail'
import technological from '@/view/technological/index'
import solution from '@/view/solution/index'
import dataCenter from '@/view/dataCenter/index'
import joinUs from '@/view/joinUs/index'
import information from '@/view/information/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },

    //产品
    {
      path: '/product',
      name: 'product',
      component: product
    },
    //案例
    {
      path: '/case',
      name: 'case',
      component: case1
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      component: caseDetail
    },
    //关于
    {
      path: '/inRegard',
      name: 'inRegard',
      component: inRegard
    },
    //联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    },

    //新闻中心
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },
    //技术创新
    {
      path: '/technological',
      name: 'technological',
      component: technological
    },

    //解决方案
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },

    //资料中心
    {
      path: '/dataCenter',
      name: 'dataCenter',
      component: dataCenter
    },
    // 加入我们
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    },

    //立即咨询
    {
      path:'/information',
      name:"information",
      component:information
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js